

// 网购退货——淘宝，主流程
const tbMainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `refund/tb/index${i + 1}`,
  name: `refundTbIndex${i + 1}`,
  component: () => import(`@/views/shopping/refund/tb/index${i + 1}.vue`),
}));
// 网购退货——淘宝，分支1
const tbBranch1Routes = Array.from({ length: 6 }, (_, i) => ({
  path: `refund/tb/branch1/index${i + 1}`,
  name: `refundTbBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/shopping/refund/tb/branch1/index${i + 1}.vue`),
}));
// 网购退货——京东，主流程
const jdMainRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `refund/jd/index${i + 1}`,
  name: `refundJdIndex${i + 1}`,
  component: () => import(`@/views/shopping/refund/jd/index${i + 1}.vue`),
}));

// 网购退货——拼多多，主流程
const pddMainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `refund/pdd/index${i + 1}`,
  name: `refundPddIndex${i + 1}`,
  component: () => import(`@/views/shopping/refund/pdd/index${i + 1}.vue`),
}));
// 网购退货——拼多多，分支1
const pddBranch1Routes = Array.from({ length: 4 }, (_, i) => ({
  path: `refund/pdd/branch1/index${i + 1}`,
  name: `refundPddBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/shopping/refund/pdd/branch1/index${i + 1}.vue`),
}));
// 网购退货——拼多多，分支2
const pddBranch2Routes = Array.from({ length: 4 }, (_, i) => ({
  path: `refund/pdd/branch2/index${i + 1}`,
  name: `refundPddBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/shopping/refund/pdd/branch2/index${i + 1}.vue`),
}));

// 网购退货——抖音，主流程
const dyMainRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `refund/dy/index${i + 1}`,
  name: `refundDyIndex${i + 1}`,
  component: () => import(`@/views/shopping/refund/dy/index${i + 1}.vue`),
}));
// 网购退货——抖音，分支1
const dyBranch1Routes = Array.from({ length: 6 }, (_, i) => ({
  path: `refund/dy/branch1/index${i + 1}`,
  name: `refundDyBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/shopping/refund/dy/branch1/index${i + 1}.vue`),
}));
// 网购退货——抖音，分支2
const dyBranch2Routes = Array.from({ length: 6 }, (_, i) => ({
  path: `refund/dy/branch2/index${i + 1}`,
  name: `refundDyBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/shopping/refund/dy/branch2/index${i + 1}.vue`),
}));

export default {
  path: "/shopping",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    // 网购退货——淘宝，主流程
    ...tbMainRoutes,
    ...tbBranch1Routes,
    // 网购退货——京东，主流程
    ...jdMainRoutes,

    // 网购退货——拼多多，主流程
    ...pddMainRoutes,
    ...pddBranch1Routes,
    ...pddBranch2Routes,
    // 网购退货——抖音，主流程
    ...dyMainRoutes,
    ...dyBranch1Routes,
    ...dyBranch2Routes,

  ],
};
